import React, {useEffect, useState, useRef} from 'react'
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined, ExclamationCircleFilled, InfoCircleOutlined, UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import {Table, Empty, Modal, Form, Divider, Button, message, Space, Skeleton, Tooltip, Upload} from 'antd';
import {getFilter, insert, update, drop, importBulk, importBulkConfirm} from '../../../../apis/MovimientoDiasHorasApi';
import AnioPeriodo from '../../../../components/forms/anio_periodo';
import FormBody from './form'
import _ from 'lodash'
import {tipoIncidencias} from '@app/constants/tipoIncidencias';
import { status_period } from '../../../../constants/period'
const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Catálogos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Movimientos Días/Horas</span>
      </>
    ),
}];

const MovimientosDiasHoras = () => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(null);
    const [items, setItems] = useState([]);
    const [objectSelected, setObjectSelected] = useState(null);
    const [disabledForm, setDisabled] = useState(true);
    const [header, setHeader] = useState(null);
    const [loading, setLoading] = useState(false);
    const [period, setPeriod] = useState(null);  
    const [uploading, setUploading] = useState(false);
    
    const columns = [
      {
        title: 'Empleado',
        dataIndex: 'empleado',
        key: 'empleado',
      },
      {
        title: 'Tipo Incidencia',
        dataIndex: 'tipo_incidencia',
        key: 'tipo_incidencia',
        render: (item, object)=> {
          var incidencia = _.find(tipoIncidencias.list, (x)=> x.value == object.tipo_incidencia);
          return <Space>
            {incidencia ? incidencia.text : 'N/A'}
          </Space>
        }
      },
      {
        title: 'Dias',
        dataIndex: 'dias',
        key: 'dias',
        render: (item, object)=> {
          var incidencia = _.find(tipoIncidencias.list, (x)=> x.value == object.tipo_incidencia);
          return <Space>
            {item}
            <Tooltip title={incidencia ? incidencia.name + '_dias' : 'N/A'}>
              <InfoCircleOutlined />
            </Tooltip>
          </Space>
        }
      },
      {
        title: 'Horas',
        dataIndex: 'horas',
        key: 'horas',
        render: (item, object)=> {
          var incidencia = _.find(tipoIncidencias.list, (x)=> x.value == object.tipo_incidencia);
          return <Space>
            {item}
            <Tooltip title={incidencia ? incidencia.name + '_horas' : 'N/A'}>
              <InfoCircleOutlined />
            </Tooltip>
          </Space>
        }
      },
      {
        title: 'Referencia',
        dataIndex: 'referencia',
        key: 'referencia',
        render: (text) => {
          return text ? text : 'NA';
        }
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        render: (item, object)=> {
          return <Space>
          <Button type='primary' size='small' onClick={()=>{
              onEdit(object);
          }}>Editar</Button>
          <Button type='primary' size='small' danger onClick={()=>{
              deleteConfirm(object);
          }}>Eliminar</Button>
        </Space>
        }
      }
    ];

    const headerRef = React.createRef();
    const bodyRef = React.createRef();

    const handleOk = async () => {
      try {
          const values = await form.validateFields();
          if(!values) return;
      } catch (errorInfo) {
          console.log('Failed:', errorInfo);
          return;
      }

      let success = false;
      const fields = form.getFieldsValue()
      if(objectSelected?.id > 0){
          //Update
          const payload = {
              id: objectSelected?.id,
              ...fields,
          }
          const response = await update(payload);
          success = response.ok;
          if(response.ok){
              message.success('Se actualizó correctamente el movimiento!');
          }
      }else{
          //Create
          const payload = {
              ...fields,
          }
          const response = await insert(payload);
          success = response.ok;
          if(response.ok){
              // setID(response.payload);
              message.success('Se guardo correctamente el movimiento!');
          }
      }

      if(success){
        await resetBody();
        await refreshData(header);
      }
    }

    const resetBody = async ()=>{
      setObjectSelected(null);
      let values = await form.getFieldValue();
      form.resetFields();
      form.setFieldsValue({
        periodo_id: values.periodo_id,
        anio: values.anio,
        num_periodo: values.num_periodo,
      });
    }

    const onEdit = async (object)=>{
        setObjectSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar la movimiento?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
      setLoading(true);
        const response = await drop(id);
        if(response.ok){
            message.success('¡El movimiento ha sido eliminado!');
        }
        await refreshData(header);
    }

    const refreshData = async (values)=> {
      setLoading(true);
      const response = await getFilter(values.periodo_id, values.anio, values.num_periodo);
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }

      setLoading(false);
    }

    const onBlurHeader = async (values, period)=> {
      setHeader(values)
      if(values?.anio && values?.num_periodo && values?.periodo_id){
        setDisabled(false);
        await refreshData(values);
      }else{
        setDisabled(true);
      }

      if(period){
        setPeriod(period);
      }else{
        setPeriod(null)
      }
    }

    const handleImport = async (file, _fileList) => {
      const forceSave = false;

      if (!header?.periodo_id || !header?.anio || !header?.num_periodo) {
        message.error('Debe seleccionar un periodo antes de importar');
        return false;
      }

      setUploading(true);
      let shouldStopLoading = true;

      try {
        const response = await importBulk(
          file,
          header.periodo_id,
          header.anio,
          header.num_periodo,
          forceSave
        );

        if (response.ok) {
          const result = response.payload;

          if (result.requires_confirmation) {
            shouldStopLoading = false;
            Modal.confirm({
              title: 'Confirmar importación con errores',
              icon: <ExclamationCircleFilled />,
              content: (
                <div>
                  <p>{result.message}</p>
                  <p style={{marginTop: 16}}>Total de registros: {result.total}</p>
                  <p>Registros exitosos: {result.successful}</p>
                  <p>Registros fallidos: {result.failed}</p>
                  {result.errors && result.errors.length > 0 && (
                    <>
                      <p style={{marginTop: 16, fontWeight: 'bold'}}>Errores encontrados:</p>
                      <ul style={{maxHeight: 200, overflow: 'auto', fontSize: '12px'}}>
                        {result.errors.map((error, index) => (
                          <li key={index}>{error}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
              ),
              width: 700,
              okText: 'Sí, guardar registros exitosos',
              cancelText: 'No, cancelar importación',
              onOk: async () => {
                setUploading(true);
                const confirmedResponse = await importBulkConfirm(
                  header.periodo_id,
                  header.anio,
                  header.num_periodo,
                  result.cached_records
                );

                if (confirmedResponse.ok) {
                  const confirmedResult = confirmedResponse.payload;
                  if (confirmedResult.saved) {
                    message.success(`Se guardaron correctamente ${confirmedResult.successful} movimientos`);
                    await refreshData(header);
                  }
                }
                setUploading(false);
              },
              onCancel: () => {
                message.info('Importación cancelada');
                setUploading(false);
              }
            });
          } else {
            if (result.failed > 0) {
              Modal.warning({
                title: 'Importación completada con errores',
                content: (
                  <div>
                    <p>Total de registros: {result.total}</p>
                    <p>Exitosos: {result.successful}</p>
                    <p>Fallidos: {result.failed}</p>
                    {result.errors && result.errors.length > 0 && (
                      <>
                        <p style={{marginTop: 16, fontWeight: 'bold'}}>Errores:</p>
                        <ul style={{maxHeight: 200, overflow: 'auto'}}>
                          {result.errors.map((error, index) => (
                            <li key={index}>{error}</li>
                          ))}
                        </ul>
                      </>
                    )}
                  </div>
                ),
                width: 600,
              });
            } else {
              message.success(`Se importaron correctamente ${result.successful} movimientos`);
            }

            if (result.saved) {
              await refreshData(header);
            }
          }
        }
      } catch (error) {
        message.error('Error al importar el archivo');
      } finally {
        if (shouldStopLoading) {
          setUploading(false);
        }
      }

      return false;
    };

    const downloadTemplate = () => {
      const csvContent = 'num_empleado,tipo_incidencia,dias,horas,referencia\n' +
                         '4,21,1,0,Ajuste de días\n' +
                         '2,5,,8,Horas extras dobles\n' +
                         '3,1,0,20,Tiempo ordinario';
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'plantilla_movimientos_diashoras.csv';
      link.click();
    };

    const isPeriodClosed = () => {
      if (!period || !period.status) return false;
      return period.status >= status_period.cerrado;
    };

    return <PageApp 
      routes={routes}
      title={'Movimientos de Dias/Horas'}>
        <>
          <AnioPeriodo ref={headerRef} onBlur={onBlurHeader} form={form} disabledForm={objectSelected && objectSelected.id > 0}/>
          <Space style={{marginTop: 16, marginBottom: 16}}>
            <Upload
              beforeUpload={handleImport}
              accept=".csv,.xlsx,.xls"
              showUploadList={false}
              disabled={disabledForm || uploading || isPeriodClosed()}
            >
              <Tooltip 
                title={isPeriodClosed() ? `No se puede importar en un período cerrado. Estado: ${period?.status_text || 'Desconocido'}` : ''}
                placement="top"
              >
                <Button 
                  icon={<UploadOutlined />} 
                  disabled={disabledForm || uploading || isPeriodClosed()}
                  loading={uploading}
                >
                  Importar Movimientos
                </Button>
              </Tooltip>
            </Upload>
            <Button 
              icon={<DownloadOutlined />} 
              onClick={downloadTemplate}
            >
              Descargar Plantilla
            </Button>
          </Space>
          <Divider/>
          {
            objectSelected && objectSelected.id > 0 && 
            <FormBody ref={bodyRef} onOk={handleOk} onCancel={resetBody} form={form} disabledForm={disabledForm} object={objectSelected} period={period}/>
          }
          {
            !objectSelected && 
            <FormBody ref={bodyRef} onOk={handleOk} form={form} disabledForm={disabledForm} period={period}/>
          }
          <Divider/>
        </>

      {
          loading ?
          <Skeleton  loading={loading}/>:
          <>
            {
              items.length == 0 ? <Empty />:
              <Table dataSource={items} columns={columns} />
            }
          </>
      }
      {/* {
        (openEdit && objectSelected && objectSelected.id > 0) &&
        <ModalEdit title={"Editar Saldo"} id={objectSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !objectSelected) &&
        <ModalEdit title={"Crear Saldo"} open={openEdit} finish={onHandlerFinish}/>
      } */}
    </PageApp>
}   

export default MovimientosDiasHoras;
